import { css } from '@emotion/css'
import { Color, RgbColor } from 'utils/variables'
import { buttonInteraction } from 'utils/mixin'

export const body = css(
  buttonInteraction,
  css`
  width: 42px;
  height: 42px;
  background: rgba(${RgbColor.Black}, 0.7);
  border-radius: 200px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`
);

export const icon = css`
  fill: ${Color.White};
`;